// extracted by mini-css-extract-plugin
export var chip = "_5r-9";
export var chipLabel = "_5r-a";
export var close = "_5r-7";
export var closeIcon = "_5r-8";
export var error = "_5r-6";
export var infoTooltip = "_5r-2";
export var innerContainer = "_5r-1";
export var input = "_5r-b";
export var medium = "_5r-5";
export var outerContainer = "_5r-0";
export var small = "_5r-4";
export var xSmall = "_5r-3";